import React from 'react';

/**
 * Scans tab — read-only list of the most recent scans.
 */
export default function ScansTab({ scans }) {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden" data-testid="admin-scans-tab">
      {scans.items.length === 0 ? (
        <div className="p-6 text-zinc-500 text-sm text-center" data-testid="scans-empty">No scans yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="scans-table">
            <thead className="bg-zinc-950 text-zinc-400 text-xs uppercase">
              <tr>
                <th className="text-left px-4 py-2">When</th>
                <th className="text-left px-4 py-2">Barcode</th>
                <th className="text-left px-4 py-2">Type</th>
                <th className="text-left px-4 py-2">User</th>
                <th className="text-left px-4 py-2">Has prices?</th>
              </tr>
            </thead>
            <tbody>
              {scans.items.map((s) => (
                <tr
                  key={`${s.scanned_at || ''}-${s.barcode}-${s.user_id || ''}`}
                  className="border-t border-zinc-800"
                  data-testid="scans-row"
                >
                  <td className="px-4 py-2 text-zinc-500 text-xs">{(s.scanned_at || '').slice(0, 19).replace('T', ' ')}</td>
                  <td className="px-4 py-2 font-mono text-[#FFD700]">{s.barcode}</td>
                  <td className="px-4 py-2 text-xs">{s.type}</td>
                  <td className="px-4 py-2 text-xs text-zinc-400 font-mono">{(s.user_id || '').slice(0, 8)}…</td>
                  <td className="px-4 py-2">{s.has_prices ? <span className="text-[#00D26A]">✓</span> : <span className="text-zinc-600">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
